import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Layout, Menu, theme } from "antd";
import { UserOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { BookingPage } from "./admin-booking";
import { GalleryPage } from "./admin-gallery";
import { Navigation } from "./navigation";
import { useAuth } from "../App";

const { Header, Content, Footer, Sider } = Layout;

export const AdminDashboard = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname;
  // console.log("pathname login", pathname);
  console.log("user login now", user);

  const [collapsed, setCollapsed] = useState(false);

  const handleMenuClick = () => {
    setCollapsed(true);
  };

  const menuItems = [
    {
      key: "booking",
      icon: <UserOutlined />,
      label: (
        <Link to="/booking" onClick={handleMenuClick}>
          Booking
        </Link>
      ),
    },
    {
      key: "gallery",
      icon: <VideoCameraOutlined />,
      label: (
        <Link to="/gallery" onClick={handleMenuClick}>
          Gallery
        </Link>
      ),
    },
  ];

  let pageContent;
  if (pathname === "/admin" || pathname === "/admin/" || pathname === "/") {
    pageContent = <BookingPage />;
  } else if (pathname === "/booking") {
    pageContent = <BookingPage />;
  } else if (pathname === "/gallery") {
    pageContent = <GalleryPage />;
  } else {
    pageContent = <div>404 Not Found</div>;
  }

  return (
    <div>
      <Navigation isLogin={true} />
      <Layout style={{ paddingTop: 80, minHeight: "100vh" }}>
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          // collapsed={collapsed}
          // onCollapse={(collapsed) => setCollapsed(collapsed)}
        >
          <div className="logo" style={{ height: "32px", margin: "16px" }} />
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["booking"]}
            items={menuItems}
          />
        </Sider>
        <Layout>
          <Header style={{ padding: 0, background: colorBgContainer }} />
          <Content style={{ margin: "24px 16px 0" }}>
            <div
              style={{
                padding: 24,
                minHeight: 360,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
              }}
            >
              {pageContent}
            </div>
          </Content>
          <Footer style={{ textAlign: "center" }}>Admin Dashboard</Footer>
        </Layout>
      </Layout>
    </div>
  );
};
